import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import { type RecurringDateData } from '@/Shared/AutoGenerated/Main'

export default class RecurringDate {
    constructor(
        public readonly localizedReadableDateTime: string,
        public readonly localizedReadableDate: string,
        public readonly localizedReadableTime: string,
        public readonly localizedDayOfWeekShort: string,
        public readonly localizedDayOfWeekLong: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    getLocalizedDescription(): string {
        return `${this.localizedDayOfWeekShort}, ${this.localizedReadableDateTime}`
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: RecurringDateData): RecurringDate {
        return new RecurringDate(
            entityData.localizedReadableDateTime,
            entityData.localizedReadableDate,
            entityData.localizedReadableTime,
            entityData.localizedDayOfWeekShort,
            entityData.localizedDayOfWeekLong,
        )
    }

    static hydrateMultiple(entitiesData: RecurringDateData[]): RecurringDate[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
